type RiskFieldsInput = {
  riskScore?: number | null;
  recoveryDays?: number | null;
  readinessScore?: number | null;
};

const measured = (v: number | null | undefined): number | null =>
  v === null || v === undefined ? null : v;

/**
 * Board Reports' risk fields from /business-intelligence, passed through as measured.
 * A measured 0 stays 0; absent is null, never the old 59 / 20 defaults.
 */
export function boardReportRiskFields(api: RiskFieldsInput) {
  const riskScore = measured(api.riskScore);
  const readinessScore = measured(api.readinessScore) ?? (riskScore === null ? null : 100 - riskScore);
  return { riskScore, recoveryDays: measured(api.recoveryDays), readinessScore };
}
